<template>
    <v-app id="main">
        <alert></alert>
        <v-app-bar color="#28313B" dark dense fixed clipped-left app style="height:5vh">
            <a href="/">
                <img :src="computeLogo" style="height:3.6vh; vertical-align:middle" alt="PressGaney" link>
            </a>
            <!--<v-toolbar-title class="headline" style="padding-left: inherit;">
                <a href="/" class="white--text" style="text-decoration: none; font-size:2.5vh">PressGaney</a>
            </v-toolbar-title>-->
            <v-divider class="mx-3"
                       inset
                       vertical></v-divider>
            <v-toolbar-items v-if="isAuthenticated" class="hidden-sm-and-down">
                <span v-for="(routerlink,index) in routerlinks" v-bind:key="routerlink.routerlink.value">
                    <span v-if="routerlink.routerlink.value.toLowerCase().includes('usermanagement') && isInternalAdmin(routerlink.routerlink.value)">
                        <v-btn v-bind:key="routerlink.routerlink.value"
                               :to="routerlink.routerlink.value">
                            {{routerlink.routerlink.text}}
                        </v-btn>
                    </span>
                    <span v-else-if="!routerlink.routerlink.value.toLowerCase().includes('usermanagement')">
                        <v-btn v-bind:key="routerlink.routerlink.value"
                               :to="routerlink.routerlink.value">
                            <v-icon left v-if="index>1">keyboard_arrow_right</v-icon>
                            <span v-bind:class="{ 'blue--text' : !checkIndex(index) }">{{routerlink.routerlink.text}}</span>
                        </v-btn>
                    </span>
                </span>
            </v-toolbar-items>
            <v-spacer></v-spacer>
            <v-menu v-if="false" offset-y origin="center center" :nudge-bottom="10" transition="scale-transition">
                <v-btn icon large flat slot="activator">
                    <v-avatar size="32px">
                        <img src="https://randomuser.me/api/portraits/men/1.jpg" />
                    </v-avatar>
                </v-btn>
                <v-list class="pa-0">
                    <v-list-tile v-for="(item, index) in items"
                                 :to="!item.href ? { name: item.name } : null"
                                 :href="item.href"
                                 ripple="ripple"
                                 :disabled="item.disabled"
                                 :target="item.target"
                                 rel="noopener"
                                 :key="index">
                        <v-list-tile-action v-if="item.icon">
                            <v-icon>{{ item.icon }}</v-icon>
                        </v-list-tile-action>
                        <v-list-tile-content>
                            <v-list-tile-title>{{ item.title }}</v-list-tile-title>
                        </v-list-tile-content>
                    </v-list-tile>
                </v-list>
            </v-menu>
            <v-spacer></v-spacer>
            <v-menu offset-y v-if="isAuthenticated">
                <template v-slot:activator="{ on, attrs }">
                    <span v-bind="attrs" v-on="on">
                        <span class="pr-2">{{ getUserName() }}</span>
                        <v-icon>mdi-arrow-down-drop-circle-outline</v-icon>
                    </span>
                </template>
                <v-list>
                    <v-list-item>
                        <v-list-item-title disabled>{{ getUserEmail() }}</v-list-item-title>
                    </v-list-item>
                    <v-list-item>
                        <v-list-item-title><v-btn v-on:click.native="logout()" dark>Sign Out</v-btn></v-list-item-title>
                    </v-list-item>
                </v-list>
            </v-menu>
        </v-app-bar>
        <v-main style="padding:0px; margin-top:5vh">
            <vue-progress-bar></vue-progress-bar>
            <router-view />
            <v-footer app class="appFooter">
                <v-layout justify-center row wrap><strong>&copy; {{ currentYear }} Press Ganey Associates LLC. All Rights Reserved. a PG Forsta company.</strong></v-layout>
            </v-footer>
        </v-main>
    </v-app>
</template>
<script>
    import { mapState } from 'vuex';
    import alert from './components/Modules/Shared/_partial/Alert'
    import OktaUserDetails from './Helpers/OktaUserDetails'

    export default {
        name: "App",
        components: {
            alert
        },
        data: () => ({
            drawer: null,
            authenticated: false,
            claims: null,
            items: [
                {
                    icon: "account_circle",
                    href: "#",
                    title: "Profile",
                },
                {
                    icon: "settings",
                    href: "#",
                    title: "Settings",
                },
                {
                    icon: "fullscreen_exit",
                    href: `${process.env.VUE_APP_NEXUSPORTAL_LOGIN_URL}`,
                    title: "Home"
                }
            ],
            isIndexZero: 0,
            goToLanding() {
                window.location.href = `${process.env.VUE_APP_NEXUSPORTAL_LANDING_URL}`;
            },
            //Logout() {
            //   // window.location.href = `${process.env.VUE_APP_NEXUSPORTAL_LOGIN_URL}`;
            //    window.location.href = `${process.env.VUE_APP_ROOT_UAM_LOGIN_URL}` + this.authNRequest;
            //}
        }),
        props: {
            source: String
        },
        watch: {
            // Everytime the route changes, check for auth status
          //  '$route': 'isAuthenticated'
        },
        methods: {
            checkIndex(index) {
                if (index == 0 || index == 1) return true;
                else return false;
            },
            async logout() {
                this.$store.dispatch('Authentication/logout');
                window.location.href = `${process.env.VUE_APP_ROOT_UAM_LOGOUT_URL}` + this.authNRequest;
              //  window.location.href = `${process.env.VUE_APP_ROOT_UAM_LOGIN_URL}` + this.authNRequest;
            },
            getUserName() {
                this.isRoleValid();
                if (this.isAuthenticated) {
                    const oktaUserDetails = new OktaUserDetails();
                    return oktaUserDetails.getUserName();
                }
                else return '';
            },
            getUserEmail() {
                if (this.isAuthenticated) {
                    const oktaUserDetails = new OktaUserDetails();
                    return oktaUserDetails.getUserEmailId();
                } else return '';
            },
            isInternalAdmin() {
                let rolename = process.env.VUE_APP_ADMIN_ROLE_NAME;
                const oktaUserDetails = new OktaUserDetails();

                let internalAdmin = oktaUserDetails.getUserRoles().filter(role => role.toLowerCase() == rolename.toLowerCase());
                if (internalAdmin.length > 0) return true;
                else return false;
            },
            isRoleValid() {

                let roles = process.env.VUE_APP_ALL_ROLE_NAMES;
                var roleslist = roles.split(",").map(function (item) {
                    return item.trim();
                });

                const oktaUserDetails = new OktaUserDetails();
                let userroles = oktaUserDetails.getUserRoles();
                let validRole = roleslist.some(item => userroles.includes(item));

                if (oktaUserDetails.getUserId() === "") { // user did not login.
                    window.location.href = `${process.env.VUE_APP_ROOT_UAM_LOGIN_URL}` + this.authNRequest;
                }
                else if (!validRole) {                    
                    this.$router.push("/UnAuthorized"); // user is authenticated but not authorized.
                }  
            }
        },
        computed: {
            theme() {
                return this.$vuetify.theme;
            },
            computeLogo() {
                return "/img/PG_Logo_RGB_White.png";
            },
            computeLoginLogo() {
                return "/img/icons/login.png";
            },
            currentYear() {
                return new Date().getFullYear();
            },
            ...mapState({
                routerlinks: state => state.AppStore.routerlinks,
                isAuthenticated: state => state.Authentication.IsAuthenticated,
                authNRequest: state => state.Authentication.authNRequest,
            }),
        },
        created() {
            this.$Progress.start()
            this.$store.dispatch('Authentication/IsAuthenticated');

            if (!this.isAuthenticated) {
                window.location.href = `${process.env.VUE_APP_ROOT_UAM_LOGIN_URL}` + this.authNRequest;
            } 

            this.$router.beforeEach((to, from, next) => {
                //  does the page we want to go to have a meta.progress object
                if (to.meta.progress !== undefined) {
                    let meta = to.meta.progress
                    this.$Progress.parseMeta(meta)
                }
                this.$Progress.start()
                next()
            })
            this.$router.afterEach((to, from, next) => {
                this.$Progress.finish()
            })
        },
    };
</script>